<template>
	<span>
		<v-navigation-drawer app v-model="drawer" class="black-white lighten-2" dark disable-resize-watcher
			:right="drawerRight">
			<v-list nav>
				<v-list-item two-line class="tile">
					<v-list-item-avatar>
						<img src="https://pazarsystem.com/favicon.ico" />
					</v-list-item-avatar>

					<v-list-item-content>
						<v-list-item-title class="title">PAZAR</v-list-item-title>
						<!-- <v-list-tile-subtitle>آسان و قدرتمند</v-list-tile-subtitle> -->
					</v-list-item-content>
				</v-list-item>

				<v-divider></v-divider>

				<v-list-item class="tile" active-class="highlighted" v-for="(item, index) in drawerItems" :key="index"
					router :to="item.link">
					<v-list-item-icon>
						<v-icon right>{{ item.icon }}</v-icon>
					</v-list-item-icon>

					<v-list-item-content>
						<v-list-item-title>{{ item.title }}</v-list-item-title>
					</v-list-item-content>
				</v-list-item>
			</v-list>
		</v-navigation-drawer>

		<v-app-bar app color="grey darken-4" dark>
			<v-btn icon class="hidden-md-and-up" @click="drawer = !drawer">
				<v-icon>menu</v-icon>
			</v-btn>

			<v-spacer class="hidden-md-and-up"></v-spacer>

			<v-toolbar-items>
				<v-card v-for="(item, index) in toolbarItems" :key="index">
					<v-btn text class="hidden-sm-and-down nav-menu text-center" :to="item.link" data-cy="menuBtn">
						<!-- <v-icon right dark>{{ item.icon }}</v-icon> -->
						{{ item.title }}
					</v-btn>
				</v-card>
			</v-toolbar-items>

			<v-spacer class="hidden-sm-and-down"></v-spacer>

			<!-- Shortcuts -->
			<v-btn v-on:click="requestForm" class="px-3 mx-3 white--text" icon target="_blank"><v-icon
					size="32px">mdi-face-agent</v-icon>
			</v-btn>

			<v-btn text class="nav-menu" href="https://pazarcloud.com" target="_blank" data-cy="menuBtn1">
				<v-icon color="white">mdi-chart-bar</v-icon><span class="hidden-md-and-down">پرتال مشتریان</span>
			</v-btn>

			<v-btn text class="nav-menu" href="https://asan360.com" target="_blank" data-cy="titleBtn">
				<v-icon color="white">mdi-cloud-search-outline</v-icon><span class="hidden-md-and-down">ASAN360</span>
			</v-btn>

			<!-- <v-btn text class="nav-menu" to="/docs" v-if="$store.state.isAuthenticated" data-cy="menuBtn"><v-icon color="white">mdi-school</v-icon><span class="hidden-md-and-down">آموزش</span> </v-btn> -->
			<v-btn text class="nav-menu" to="/docs" data-cy="menuBtn"><v-icon color="white">mdi-school</v-icon><span
					class="hidden-md-and-down">آموزش</span>
			</v-btn>

			<v-btn text class="nav-menu" to="/purchaseform" data-cy="menuBtn">
				<v-icon>shopping_cart</v-icon>
			</v-btn>

			<v-btn text class="nav-menu" @click="login()" v-if="!$store.state.isAuthenticated" data-cy="menuBtn">
				<v-icon color="green">mdi-login</v-icon>
			</v-btn>
			<v-btn text class="nav-menu" @click="logout()" v-if="$store.state.isAuthenticated" data-cy="menuBtn">
				<v-icon color="yellow">mdi-logout</v-icon>
			</v-btn>

			<v-divider color="white" class="mx-3 hidden-sm-and-down" inset light vertical></v-divider>

			<router-link to="/" class="hidden-sm-and-down">
				<v-toolbar-title data-cy="titleBtn">{{
					appTitle
				}}</v-toolbar-title>
			</router-link>
		</v-app-bar>
	</span>
</template>

<script>
export default {
	name: "AppNavigation",
	data() {
		return {
			appTitle: "PAZAR",
			pazarpluslink: "http://pazarplus.ir",
			drawer: false,
			drawerRight: true,
			toolbarItems: [
				{ title: "صفحه نخست", link: "/", icon: "mdi-home" },
				{ title: "محصولات", link: "/products", icon: "mdi-view-list" }, //'mdi-view-dashboard'
				{
					title: "پشتیبانی",
					link: "/download",
					icon: "mdi-cloud-download",
				},
				{
					title: "درباره ما",
					link: "/about",
					icon: "mdi-information-variant",
				},
				{
					title: "تماس با ما",
					link: "/contact",
					icon: "mdi-face-agent",
				},
			],
			drawerItems: [
				{ title: "صفحه نخست", link: "/", icon: "mdi-home" },
				{ title: "محصولات", link: "/products", icon: "mdi-view-list" }, //'mdi-view-dashboard'
				{
					title: "پشتیبانی",
					link: "/download",
					icon: "mdi-cloud-download",
				},
				{ title: "آموزش", link: "/docs", icon: "mdi-school" },
				{
					title: "درباره ما",
					link: "/about",
					icon: "mdi-information-variant",
				},
				{
					title: "تماس با ما",
					link: "/contact",
					icon: "mdi-face-agent",
				},
			],
		};
	},
	// computed: {
	// 	isAuthenticated() {
	// 		return this.$store.getters.isAuthenticated;
	// 	},
	// },
	mounted: async function () {
		await this.$store.dispatch("getPriceList");
		if (this.$store.state.pazarVersions.length < 1) {
			this.$store.dispatch("getPazarVersions");
		}
		if (this.$store.state.filesLinks.length < 1) {
			this.$store.dispatch("getFilesLinks");
		}
	},
	methods: {
		changeRTL() {
			this.$vuetify.rtl = true;
		},
		login() {
			if (!this.$store.state.isAuthenticated) {
				const redirectPath = window.location.pathname;
				// console.info(redirectPath);
				this.$router.push({
					name: "login",
					query: { redirect: redirectPath },
				});
			}
		},
		logout() {
			this.$store.dispatch("userLogout");
		},
		requestForm() {
			const redirect = window.location.pathname;
			// console.info(redirect);
			if (!redirect.toLowerCase().includes("/supportform")) {
				const path = `/supportform?redirect=${redirect}`;
				this.$router.push(path);
			}
		},
	},
};
</script>

<style scoped>
a {
	color: white;
	text-decoration: none;
}

.tile {
	color: whitesmoke;
	margin: 5px;
	border-radius: 4px;
}
</style>
